const russianAlphabet = [...'абвгдеёжзийклмнопрстуфхцчшщъыьэюя'];
const englishAlphabet = [...'abcdefghijklmnopqrstuvwxyz'];

export {
    russianAlphabet,
    englishAlphabet
};